import React, { useEffect, useRef, useState } from 'react'
import styles from '../styles/vipBenefits.module.scss'
import VipLists from './vipLists'
import { useTranslation } from 'react-i18next'
import { useVipWeekInfo } from '../hooks/useVip'


const VipBenefits = ({vipWeek}) => {
  const { t } = useTranslation('vip')
  
  return (
    <div className={styles.vipBenefits}>
      <div className={styles.upgrade_title}>
        <div>VIP benefits</div>
        <div>{t('vipBenefits.vipBenefits')}</div>
      </div>

      <div className={styles.tip}>{t('vipBenefits.trxConversionNote')}</div>

      <VipLists 
        list={vipWeek?.list}
        onTitle = {function (v:any,index3:number){
          return <div key={index3}>{v.title}</div>;
        }}
        onValue={function (e: any, x: any, index1, index2) {
          return <div key={index2}>{x?.[`vip${index1}`]}</div>;
        }}
      />
    </div>
    )
  }
export default VipBenefits
